import { motion } from "framer-motion";
import { Monitor, ShoppingCart, Cpu, Settings } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const icons = [Monitor, ShoppingCart, Cpu, Settings];
const numbers = ["01", "02", "03", "04"];

const Services = () => {
  const { t } = useLanguage();

  return (
    <section
      id="szolgaltatasok"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
          className="max-w-3xl mb-16 md:mb-20"
        >
          <span className="inline-block text-xs md:text-sm font-medium uppercase tracking-[0.25em] text-[#3B82F6] mb-6">
            {t.services.label}
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1B2A4A] leading-[1.1] tracking-tight">
            {t.services.headingStart}{" "}
            <span className="italic font-medium">
              {t.services.headingItalic}
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {t.services.items.map((s, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{
                  duration: 0.7,
                  delay: i * 0.1,
                  ease: [0.25, 0.1, 0.25, 1],
                }}
                className="group relative bg-white border border-[#1B2A4A]/10 rounded-2xl p-8 md:p-10 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-[0_20px_50px_-15px_rgba(27,42,74,0.18)] hover:border-[#1B2A4A]/20"
              >
                <span className="absolute top-6 right-8 font-serif text-sm font-medium text-[#1B2A4A]/30 tracking-wider">
                  {numbers[i]}
                </span>

                <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-[#F8FAFC] border border-[#1B2A4A]/5 mb-6 transition-colors duration-500 group-hover:bg-[#1B2A4A] group-hover:border-[#1B2A4A]">
                  <Icon
                    strokeWidth={1.5}
                    className="w-6 h-6 text-[#1B2A4A] transition-colors duration-500 group-hover:text-white"
                  />
                </div>

                <h3 className="font-serif text-2xl md:text-[1.7rem] font-semibold text-[#1B2A4A] leading-snug mb-4">
                  {s.title}
                </h3>
                <p className="text-base text-[#475569] leading-relaxed font-light">
                  {s.text}
                </p>

                <div className="mt-8 pt-6 border-t border-[#1B2A4A]/5 flex items-center justify-between">
                  <span className="text-xs uppercase tracking-[0.2em] text-[#475569]">
                    {t.services.more}
                  </span>
                  <span className="inline-block transition-transform duration-300 group-hover:translate-x-1 text-[#1B2A4A]">
                    →
                  </span>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
